import { isReference } from '@bloomreach/spa-sdk';
import { NestedContentFields, LinkFields, imageFields } from '../enums/helperEnums';

export default {
  getDocument(component, page) {
    if(!component) return

    const docRef = Object.values(component.getModels())[0];

    if (!docRef) return
    return page.getContent(docRef)
  },
  getImage(imageRef, page) {
    const imageSet = page.getContent(imageRef);
    return imageRef
      ? {
          desktop: imageSet?.getOriginal().getUrl(),
          thumbnail: imageSet?.getThumbnail().getUrl(),
          mobile: imageSet?.getThumbnail().getUrl().replace('thumbnail', 'banner'),
          alt: imageSet?.getDisplayName()
        }
      : {}
  },
  extractComponent(data, page, properties) {
    if (isReference(data)) {
      const contentItemContent = page.getContent(data);
      data = contentItemContent ? contentItemContent.getData() : data;
    }

    let item = { ...data, properties: properties };

    const imageFieldsValues = Object.values(imageFields);

    imageFieldsValues.forEach(imageKey => {
      if (item[imageKey]) item[imageKey] = this.getImage(item[imageKey], page)
    })

    const linkFields = Object.values(LinkFields);
    linkFields.forEach(key => {
      // If the current key is 'linkUrl' or 'linkSecondaryUrl', it has to be assigned to 'link' or 'linkSecondary' respectively
      if (key === LinkFields.LinkUrl) {
        if (item[LinkFields.LinkUrl]) {
          item[LinkFields.Link] = item[LinkFields.LinkUrl];
        }
      } else if (key === LinkFields.LinkSecondaryUrl) {
        if (item[LinkFields.LinkSecondaryUrl]) {
          item[LinkFields.LinkSecondary] = item[LinkFields.LinkSecondaryUrl];
        }
      } else {
        // For the rest of the keys, if they exist, get their URLs
        if (item[key]) {
          item[key] = page.getContent(item[key])?.getUrl();
        }
      }
    })

    /**
     * Nested "content" and "items" fields are of type "Link".
     * They can be either Single (coming as an object)
     * or Multiple (coming as an array)
     */
    const nestedContentFields = Object.values(NestedContentFields);
    nestedContentFields.forEach(ncf => {
      if (ncf in item) {
        if(typeof item[ncf] !== 'string') {
          item[ncf] = Array.isArray(data[ncf])
            ? data[ncf].map(i => this.extractComponent(i, page, properties))
            : this.extractComponent(data[ncf], page, properties);
        }
      }
    })

    return item
  }
}
